import { createApiClient } from "#/shared/api/client";

/** Creates the client for an admin index's JSON filter definition. */
export function createIndexFiltersApi() {
  const api = createApiClient({ parse: false });

  return { load: (url) => api.get(url) };
}
